import { useState, useEffect } from 'react'
import { generateCompatibility } from '../utils/Compatibility'
import { supabase } from '../supabaseClient'


const ORANGE = '#FF5722'
const BG = '#0D0D0D'
const CARD = '#141414'
const BORDER = '#1f1f1f'
const GREEN = '#4CAF50'

export default function Swipe({ session, onNavigate }) {
  const [profiles, setProfiles] = useState([])
  const [current, setCurrent] = useState(0)
  const [loading, setLoading] = useState(true)
  const [swiping, setSwiping] = useState(null)
  const [matchPopup, setMatchPopup] = useState(false)
  const [currentScore, setCurrentScore] = useState(null)
  const [currentSauceLine, setCurrentSauceLine] = useState(null)
  const [generating, setGenerating] = useState(false)
  const userEmail = session?.user?.email

 
  useEffect(() => { fetchProfiles() }, []) // eslint-disable-line
  useEffect(() => {
    if (!profiles[current] || !userEmail) return

    let cancelled = false
    const profile = profiles[current]

    async function runCompatibility() {
      setGenerating(true)
      try {
        const { score, sauce_line } = await generateCompatibility(
          {
            full_name: userEmail,
            area: 'Bangalore',
            food_type: profile.food_type,
            time_slot: profile.time_slot
          },
          {
            full_name: profile.users?.full_name,
            area: profile.users?.area,
            food_type: profile.food_type,
            time_slot: profile.time_slot
          }
        )

        if (cancelled) return
        setCurrentScore(score)
        setCurrentSauceLine(sauce_line)
      } finally {
        if (!cancelled) setGenerating(false)
      }
    }

    runCompatibility()

    return () => {
      cancelled = true
    }
  }, [current, profiles, userEmail])

  async function fetchProfiles() {
    setLoading(true)
    const { data, error } = await supabase
      .from('cravings')
      .select(`
        *,
        users (
          id, full_name, age, area
        )
      `)
      .eq('is_active', true)
      .neq('user_id', session.user.id)
      .order('created_at', { ascending: false })

    if (!error && data) setProfiles(data)
    setLoading(false)
  }
  async function handleSwipe(direction) {
    if (!profiles[current]) return
    setSwiping(direction)
  
    const profile = profiles[current]
  
    // Generate real compatibility score
    const { score, sauce_line } = await generateCompatibility(
      {
        full_name: session.user.email,
        area: 'Bangalore',
        food_type: profile.food_type,
        time_slot: profile.time_slot
      },
      {
        full_name: profile.users?.full_name,
        area: profile.users?.area,
        food_type: profile.food_type,
        time_slot: profile.time_slot
      }
    )
  
    await supabase.from('swipes').insert({
      swiper_id: session.user.id,
      swiped_id: profile.user_id,
      craving_id: profile.id,
      direction,
      compatibility_score: score,
      sauce_line: sauce_line
    })
  
    if (direction === 'right') {
      const { data: existingSwipe } = await supabase
        .from('swipes')
        .select('*')
        .eq('swiper_id', profile.user_id)
        .eq('swiped_id', session.user.id)
        .eq('direction', 'right')
        .single()
  
      if (existingSwipe) {
        await supabase.from('matches').insert({
          user_1_id: session.user.id,
          user_2_id: profile.user_id,
          craving_id: profile.id
        })
        setTimeout(() => {
          setSwiping(null)
          setMatchPopup(true)
        }, 400)
        return
      }
    }
  
    setTimeout(() => {
      setSwiping(null)
      setCurrent(i => i + 1)
    }, 400)
  }
  

  const profile = profiles[current]
  

  const scoreColor = (s) =>
    s >= 85 ? GREEN : s >= 70 ? '#FFC107' : '#FF7043'

  const avatarColors = [
    '#E91E63', '#2196F3', '#9C27B0',
    '#FF9800', '#00BCD4', '#8BC34A'
  ]
  const avatarColor = avatarColors[current % avatarColors.length]

  if (loading) return (
    <div style={{
      minHeight: '100vh', background: BG,
      display: 'flex', alignItems: 'center',
      justifyContent: 'center', color: '#555',
      fontFamily: "'DM Sans', sans-serif", fontSize: 14
    }}>
      Finding your crew...
    </div>
  )

  return (
    <div style={{
      minHeight: '100vh',
      background: BG,
      fontFamily: "'DM Sans', sans-serif",
      paddingBottom: 80
    }}>

      {/* Header */}
      <div style={{
        padding: '52px 20px 20px',
        display: 'flex',
        alignItems: 'center',
        justifyContent: 'space-between'
      }}>
        <div
          onClick={() => onNavigate('home')}
          style={{
            width: 40, height: 40,
            borderRadius: '50%',
            background: CARD,
            border: `1.5px solid ${BORDER}`,
            display: 'flex', alignItems: 'center',
            justifyContent: 'center',
            cursor: 'pointer', color: '#fff', fontSize: 18
          }}
        >←</div>
        <div style={{ fontSize: 16, fontWeight: 700, color: '#fff' }}>
          Tonight's crew
        </div>
        <div style={{ fontSize: 13, color: '#444' }}>
          {profiles.length - current} left
        </div>
      </div>

      {/* No more profiles */}
      {current >= profiles.length ? (
        <div style={{
          display: 'flex', flexDirection: 'column',
          alignItems: 'center', justifyContent: 'center',
          padding: '80px 40px', textAlign: 'center', gap: 16
        }}>
          <div style={{ fontSize: 52 }}>🍽️</div>
          <div style={{ fontSize: 22, fontWeight: 800, color: '#fff' }}>
            That's everyone for now
          </div>
          <div style={{ fontSize: 14, color: '#555' }}>
            Check back later or post your own craving
          </div>
          <button
            onClick={() => onNavigate('post')}
            style={{
              background: ORANGE, color: '#fff',
              border: 'none', borderRadius: 12,
              padding: '13px 28px', fontSize: 14,
              fontWeight: 600, cursor: 'pointer',
              fontFamily: "'DM Sans', sans-serif",
              marginTop: 8
            }}
          >
            Post a craving →
          </button>
        </div>
      ) : (
        <>
          {/* Swipe card */}
          <div style={{
            margin: '0 20px',
            transform: swiping === 'right'
              ? 'translateX(120%) rotate(8deg)'
              : swiping === 'left'
                ? 'translateX(-120%) rotate(-8deg)'
                : 'none',
            opacity: swiping ? 0 : 1,
            transition: 'all 0.35s ease',
          }}>
            <div style={{
              background: CARD,
              border: `1.5px solid ${BORDER}`,
              borderRadius: 24,
              overflow: 'hidden'
            }}>

              {/* Top color band */}
              <div style={{
                background: `linear-gradient(135deg, ${avatarColor}25, ${BG})`,
                padding: '28px 24px 24px',
                display: 'flex',
                flexDirection: 'column',
                alignItems: 'center',
                gap: 12
              }}>
                <div style={{
                  width: 80, height: 80,
                  borderRadius: '50%',
                  background: `${avatarColor}22`,
                  border: `3px solid ${avatarColor}`,
                  display: 'flex', alignItems: 'center',
                  justifyContent: 'center',
                  color: avatarColor, fontWeight: 700,
                  fontSize: 28, flexShrink: 0,
                  letterSpacing: 1
                }}>
                  {(profile.users?.full_name || '')
                    .split(' ')
                    .filter(Boolean)
                    .slice(0, 2)
                    .map(w => w[0].toUpperCase())
                    .join('') || '?'}
                </div>
                <div style={{ textAlign: 'center' }}>
                  <div style={{
                    fontSize: 22, fontWeight: 800,
                    color: '#fff', letterSpacing: '-0.3px'
                  }}>
                    {profile.users?.full_name || 'Anonymous'}
                  </div>
                  <div style={{ fontSize: 13, color: '#666', marginTop: 4 }}>
                    📍 {profile.users?.area || profile.area}
                  </div>
                </div>
              </div>

              <div style={{ padding: '0 24px 28px' }}>

                {/* Compatibility score */}
                <div style={{
                  background: '#1a1a1a',
                  borderRadius: 14,
                  padding: '14px 16px',
                  marginBottom: 20,
                  display: 'flex',
                  alignItems: 'center',
                  gap: 12
                }}>
                  <div style={{ flex: 1 }}>
                    <div style={{
                      fontSize: 10, color: '#555',
                      fontWeight: 700, letterSpacing: 1.2,
                      textTransform: 'uppercase', marginBottom: 8
                    }}>
                      Compatibility
                    </div>
                    <div style={{
                      height: 5, background: '#2a2a2a',
                      borderRadius: 3, overflow: 'hidden'
                    }}>
                      <div style={{
                        height: '100%',
                        width: `${currentScore || 0}%`,
                        
                        background: scoreColor(currentScore || 75),
                        borderRadius: 3
                      }} />
                    </div>
                  </div>
                  <div style={{
                    fontSize: 30, fontWeight: 800,
                    color: scoreColor(currentScore || 75)
                  }}>
                    {generating ? '...' : `${currentScore}%`}
                  </div>
                </div>

                {/* Sauce line */}
                <div style={{
                  background: `${ORANGE}08`,
                  border: `1.5px solid ${ORANGE}20`,
                  borderRadius: 12,
                  padding: '12px 16px',
                  marginBottom: 20,
                  fontSize: 13,
                  color: '#bbb',
                  fontStyle: 'italic',
                  lineHeight: 1.6
                }}>
                  🔥 {generating ? 'Reading your sauce...' : currentSauceLine}
                </div>

                {/* Craving details */}
                <div style={{ marginBottom: 20 }}>
                  <div style={{
                    fontSize: 10, color: '#444',
                    fontWeight: 700, letterSpacing: 1.2,
                    textTransform: 'uppercase', marginBottom: 10
                  }}>
                    Tonight's craving
                  </div>
                  <div style={{ display: 'flex', gap: 8, flexWrap: 'wrap' }}>
                    {[
                      `🍽️ ${profile.food_type}`,
                      `🕗 ${profile.time_slot}`,
                      profile.area,
                      profile.restaurant_suggestion
                    ].filter(Boolean).map((tag, i) => (
                      <span key={i} style={{
                        background: '#1e1e1e',
                        color: '#888',
                        borderRadius: 8,
                        padding: '5px 10px',
                        fontSize: 12,
                        fontWeight: 500
                      }}>
                        {tag}
                      </span>
                    ))}
                  </div>
                </div>

              </div>
            </div>
          </div>

          {/* Swipe buttons */}
          <div style={{
            display: 'flex',
            justifyContent: 'center',
            alignItems: 'center',
            gap: 28,
            padding: '28px 20px'
          }}>

            {/* Pass */}
            <button
              onClick={() => handleSwipe('left')}
              style={{
                width: 64, height: 64,
                borderRadius: '50%',
                background: '#1a1a1a',
                border: '1.5px solid #2a2a2a',
                color: '#ff4444',
                fontSize: 26,
                cursor: 'pointer',
                display: 'flex',
                alignItems: 'center',
                justifyContent: 'center',
                boxShadow: '0 4px 20px #ff444420',
                transition: 'transform 0.2s'
              }}
            >
              ✕
            </button>

            {/* Join */}
            <button
              onClick={() => handleSwipe('right')}
              style={{
                width: 72, height: 72,
                borderRadius: '50%',
                background: `${GREEN}15`,
                border: `1.5px solid ${GREEN}40`,
                color: GREEN,
                fontSize: 30,
                cursor: 'pointer',
                display: 'flex',
                alignItems: 'center',
                justifyContent: 'center',
                boxShadow: `0 4px 20px ${GREEN}20`,
                transition: 'transform 0.2s'
              }}
            >
              ♥
            </button>

          </div>

          {/* Swipe hint */}
          <div style={{
            textAlign: 'center',
            fontSize: 12,
            color: '#333'
          }}>
            ✕ pass &nbsp;&nbsp; ♥ join their plan
          </div>
        </>
      )}

      {/* Match popup */}
      {matchPopup && (
        <div style={{
          position: 'fixed',
          inset: 0,
          background: '#000000ee',
          display: 'flex',
          flexDirection: 'column',
          alignItems: 'center',
          justifyContent: 'center',
          zIndex: 200,
          padding: 32,
          textAlign: 'center'
        }}>
          <div style={{ fontSize: 64, marginBottom: 16 }}>🍳</div>
          <div style={{
            fontSize: 32, fontWeight: 800,
            color: '#fff', marginBottom: 8,
            letterSpacing: '-0.5px'
          }}>
            You just got Sauced.
          </div>
          <div style={{
            fontSize: 15, color: '#666',
            marginBottom: 40, lineHeight: 1.6
          }}>
            You and {profile?.users?.full_name} are both in.
            <br />Time to make a plan.
          </div>
          <button
            onClick={() => {
              setMatchPopup(false)
              onNavigate('chat')
            }}
            style={{
              background: ORANGE, color: '#fff',
              border: 'none', borderRadius: 14,
              padding: '15px 40px', fontSize: 16,
              fontWeight: 700, cursor: 'pointer',
              fontFamily: "'DM Sans', sans-serif",
              marginBottom: 16, width: '100%', maxWidth: 320
            }}
          >
            Start chatting 💬
          </button>
          <div
            onClick={() => {
              setMatchPopup(false)
              setCurrent(i => i + 1)
            }}
            style={{
              color: '#444', fontSize: 13,
              cursor: 'pointer'
            }}
          >
            Keep swiping
          </div>
        </div>
      )}

    </div>
  )
}